import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Interactions = ({ user, isCurrentUser }) => {
  const [show, setShow] = useState(false);
  const isMobile = useSelector((state) => state.appState.isMobile);
  const { t } = useTranslation();
  const playedSports = user.sports?.filter((x) => x.sport !== '');

  useEffect(() => {
    if (!user) return;

    // setShow(user.type !== 'fan')
  }, [user]);

  if (!playedSports.length) return null;

  return (
    <Col wid="200px">
      {isCurrentUser && !isMobile && !!playedSports?.length && (
        <Clickable marg="26px 0 0" onClick={() => setShow(!show)}>
          <Row start center>
            <Col wid="24px" ht="24px" centerAll noFlex>
              <Icon type={show ? 'down' : 'right'} col={theme.GREY_50} dimensions={12} />
            </Col>

            <Text h4 marg="0 0 0 4px" col="#fff">
              {t('profile.mySports')}
            </Text>
          </Row>
        </Clickable>
      )}

      {show && (
        <Row grid numCols={4} gap="12px" pad={isMobile && '0 16px'} wid="fit-content">
          {playedSports?.map((x, i) => (
            <Row start key={i}>
              <Col
              // wid={isMobile ? '100%' : '216px'}
              >
                <Text c1 med col={'#fff'}>
                  {t('common.sport')}
                </Text>

                <Text marg="4px 0 0 12px" col={'#fff'}>
                  {t(`sports.${x.sport}`)}
                </Text>
              </Col>

              {x.position !== '' && user.type !== 'team' && (
                <Col wid={isMobile ? '100%' : '216px'} marg={isMobile ? '0' : '0 0 0 24px'}>
                  <Text c1 med col={isMobile ? '#fff' : '#000'}>
                    {t('common.position')}
                  </Text>

                  <Text marg="4px 0 0" col={isMobile ? '#fff' : '#000'}>
                    {t(`${x.sport}.${x.position}`)}
                  </Text>
                </Col>
              )}
            </Row>
          ))}
        </Row>
      )}
    </Col>
  );
};

export default Interactions;
